export const mustBeFeatherThan =
  (fileSizeMaxMo: number, fieldName: string, message?: string) => (value: any, allValues: any) => {
    const size = allValues[`${fieldName}-filesize`];
    if (!size) return undefined;

    const sizemax = fileSizeMaxMo * 1024 * 1024;
    const isFeather = size <= sizemax;

    const msg = message || `La taille du document excède ${fileSizeMaxMo} Mo.`;
    return isFeather ? undefined : msg;
  };
